"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidRgbVal = isValidRgbVal;
exports.isValidAlphaValue = isValidAlphaValue;
exports.isValidPercentageString = isValidPercentageString;
exports.isValidPercentage = isValidPercentage;
exports.isValidHue = isValidHue;

function isValidRgbVal(magnitudeString) {
  try {
    var magnitude = Number.parseFloat(magnitudeString);
    return magnitude >= 0 && magnitude <= 255;
  } catch (err) {
    return false;
  }
}

function isValidAlphaValue(magnitudeString) {
  try {
    var magnitude = Number.parseFloat(magnitudeString);
    return magnitude <= 1 && magnitude >= 0;
  } catch (err) {
    return false;
  }
}

function isValidPercentageString(magnitudeString) {
  try {
    var magnitude = Number.parseFloat(magnitudeString);
    return isValidPercentage(magnitude);
  } catch (err) {
    return false;
  }
}

function isValidPercentage(magnitude) {
  return magnitude >= 0 && magnitude <= 100;
}

function isValidHue(valueString) {
  try {
    var value = Number.parseFloat(valueString);
    return value >= 0 && value <= 360;
  } catch (err) {
    return false;
  }
}